var map = {
	"./widget-texts_cs.json": 2782,
	"./widget-texts_da.json": 2783,
	"./widget-texts_de.json": 2784,
	"./widget-texts_en.json": 2785,
	"./widget-texts_es.json": 2786,
	"./widget-texts_fi.json": 2787,
	"./widget-texts_fr.json": 2788,
	"./widget-texts_hi.json": 2789,
	"./widget-texts_it.json": 2790,
	"./widget-texts_ja.json": 2791,
	"./widget-texts_ko.json": 2792,
	"./widget-texts_nl.json": 2793,
	"./widget-texts_no.json": 2794,
	"./widget-texts_pl.json": 2795,
	"./widget-texts_pt.json": 2796,
	"./widget-texts_ru.json": 2797,
	"./widget-texts_sv.json": 2798,
	"./widget-texts_th.json": 2799,
	"./widget-texts_tr.json": 2800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2781;


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations ^\.\/widget\-texts_.*\.json$
// module id = 2781
// module chunks = 66